import { render, staticRenderFns } from "./EditPositionModal.vue?vue&type=template&id=624f2b8d&scoped=true"
import script from "./EditPositionModal.vue?vue&type=script&lang=js"
export * from "./EditPositionModal.vue?vue&type=script&lang=js"
import style0 from "./EditPositionModal.vue?vue&type=style&index=0&id=624f2b8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624f2b8d",
  null
  
)

export default component.exports